<script>
export default {
  name: 'image-upload.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      images: [],
      ...vm.value
    }
  }),
  methods: {
    async validate () {
      this.isLoading = true
      try {
        let files = await this.$refs['files-uploader'].uploadFilesAsync()
        this.form.images = [...files]
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
        this.isLoading = false
        return true
      } catch (error) {
        this.isLoading = false
        console.error(error)
        return false
      }
    },
    onDelete (file_id) {
      this.form.images = this.form.images.filter(img => img.file_id !== file_id)
    },
    onAdd () {}
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <keep-alive>
      <app-multi-file-upload
        ref="files-uploader"
        v-model="form.images"
        :max-size-mb="5"
        :allowed-extensions="['application/pdf', 'image/*']"
      />
    </keep-alive>
  </b-card>
</template>
